import { create } from "zustand";
import { userApi } from "../lib/api";

export const useUser = create((set) => ({
  user: null,
  ready: false,

  refresh: async () => {
    try {
      const { data } = await userApi.get("/user/me");
      set({ user: data, ready: true });
      return data;
    } catch {
      set({ user: null, ready: true });
      return null;
    }
  },

  register: async (email, password, name) => {
    const { data } = await userApi.post("/user/register", { email, password, name });
    localStorage.setItem("eff_user_token", data.token);
    set({ user: data.user });
    return data.user;
  },

  login: async (email, password) => {
    const { data } = await userApi.post("/user/login", { email, password });
    localStorage.setItem("eff_user_token", data.token);
    set({ user: data.user });
    return data.user;
  },

  completeGoogle: async (sessionId) => {
    const { data } = await userApi.post("/user/session", { session_id: sessionId });
    set({ user: data.user });
    return data.user;
  },

  logout: async () => {
    try { await userApi.post("/user/logout"); } catch {}
    localStorage.removeItem("eff_user_token");
    set({ user: null });
  },
}));
